module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/logo-small-05ece54ad3b533458833748c5e3d3797.png";